import React, { useEffect, useState } from "react";
import { Paper, withStyles } from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import * as actions from "../../../actions/result";
import * as category  from "../../../actions/category";
import * as service from "../../../actions/service";
import FormDialogAddResult from "../formDialog/FormDialogAddResult";
import FormDialogEditResult from "../formDialog/FormDialogEditResult";
import FormDialogDeleteResult from "../formDialog/FormDialogDeleteResult";
import * as doctor from "../../../actions/doctor";

const styles = theme => ({
    paperTable: {
        padding: theme.spacing(0),
    }
})

const ResultTable = ({ classes, ...props }) => {
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(15)

    useEffect(() => {
        props.fetchPagination(1, rowsPerPage)
        props.fetchDoctors();
        props.fetchCategories();
        props.fetchServices();
    }, [])

    const handleChangePage = async (newPage) => {
        await setPage(newPage);
        props.fetchPagination(newPage + 1, rowsPerPage)
    };

    const handleChangeRowsPerPage = async (rowsPerPage) => {
        await setRowsPerPage(rowsPerPage);
        await setPage(0);
        props.fetchPagination(1, rowsPerPage)
    };

    const handleSearch = async (searchText) => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage, searchText, searchText)
    };

    const handleFilterChange = async (title,description) => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage, title, description)
    };

    const refresh = async () => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage)
    }
    
    const columns = [
        {
            name: "id",
            label: "ID",
            options: {
                display: false,
                filter: false,
                sort: false,
            }
        },
        {
            // left side of first column is too close with the container, give more space on it
            name: "title",
            label: "Title",
            options: {
                filter: true,
                sort: false,
                customHeadRender: (columnMeta, handleToggleColumn) => {
                    return (
                        <th key={columnMeta.index} 
                            style={{
                                paddingLeft: "31px", 
                                fontWeight:500, 
                                borderBottom: "1px solid rgba(224, 224, 224, .5)" 
                                }}
                        >
                            <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-start"}}>
                                {columnMeta.label}
                            </div>
                        </th>
                    );
                },
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <span style={{marginLeft:15}}>
                            {value?.en}...
                        </span>
                    );
                }
            },
            
        },
      
        {
            name: "description",
            label: "Description",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <span style={{marginLeft:15}}>
                            {value?.en?.slice(0,80)?.replace(/<[^>]+>|&nbsp;|&amp;/g, '')}...
                        </span>
                    );
                }
            }
        },
        {
            name: "image",
            label: "Image",
            options: {
                filter: false,
                sort: false,
                display: false,
            },
        
        },
        {
            name: "gallary",
            label: "gallary",
            options: {
                filter: false,
                sort: false,
                display: false,
                default:[]
            },
        
        },
        {
            name: "doctor",
            label: "Doctor",
            options: {
                filter: false,
                sort: false,
                display: false,
            },
        
        },
        {
            name: "qna",
            label: "QNA",
            options: {
                filter: false,
                sort: false,
                display: false,
            },
        
        },
        {
            name: "icon",
            label: "icon",
            options: {
                filter: false,
                sort: false,
                display: false,
            },
        
        },
        {
            name: "categoryId",
            label: "Category",
            options: {
                filter: false,
                sort: false,
                display: false,
            }
        },
        {
            name: "services",
            label: "services",
            options: {
                filter: false,
                sort: false,
                display: false,
            }
        },
        {
            name: "videourl",
            label: "videourl",
            options: {
                filter: false,
                sort: false,
                display: false,
            }
        },
        {
            name: "",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customHeadRender: (columnMeta, handleToggleColumn) => {
                    return (
                        <th key={columnMeta.index} style={{paddingRight: "16px"}}>
                            <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-end"}}>
                                <FormDialogAddResult component={Paper}  
                                    create={props.create}
                                    refresh={refresh}
                                    doctors ={ props.doctors}
                                    categories ={ props.categories}
                                    services ={ props.services}
                                />
                            </div>
                        </th>
                    );
                },
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-end"}}>
                            <FormDialogEditResult
                                dataResult={tableMeta.rowData}
                                update={props.update}
                                doctors ={ props.doctors}
                                categories ={ props.categories}
                                services ={ props.services}
                            />
                            <FormDialogDeleteResult 
                                dataResult={tableMeta.rowData}
                                delete={props.delete}
                                refresh={refresh}
                            />
                        </div>
                    );
                }
            }
        }
    ];

    const options = {
        filter: false,
     
        filterType: 'textField',
        responsive: 'stacked',
        selectableRows: false,
        rowsPerPageOptions: [5, 10, 25],
        serverSide: true,
        viewColumns: false,
        print: false,
        download: false,

        rowsPerPage: rowsPerPage,
        count: props?.meta?.totalDocs || 0,
        page: page,

        onTableChange: (action, tableState) => {
            switch (action) {
              case 'changePage':
                handleChangePage(tableState.page)
                break;

            case 'changeRowsPerPage':
                handleChangeRowsPerPage(tableState.rowsPerPage)
                break;

            case 'search':
                handleSearch(tableState.searchText)
                break;

            case 'filterChange':
                handleFilterChange(tableState.filterList[1], tableState.filterList[2])
                break;
            
            case 'resetFilters':
                handleSearch("")
                break;
                 
              default:
                break;
            }
        },
    };
    
    return (
        <MUIDataTable className={classes.paperTable}
            data={props.results}
            columns={columns}
            options={options}
        />
    );
}

const mapStateToProps = state => ({
    results: state?.result?.results,
    meta: state?.result?.metaResult,
    doctors: state.doctor.doctors,
    categories: state.category.categories,
    services: state?.service?.services,
})

const mapActionToProps = {
    fetchPagination: actions.Pagination,
    create: actions.create,
    update: actions.update,
    delete: actions.Delete,
    fetchDoctors : doctor.fetchAll,
    fetchCategories : category.fetchAll,
    fetchServices : service.fetchAll,
}

export default connect(mapStateToProps, mapActionToProps)(withStyles(styles)(ResultTable));